import { createTheme, ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { AppBar, Box, Grid, IconButton, Toolbar, Typography, Avatar, Snackbar } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'

import { Suspense, useEffect, useRef, useState } from 'react'
import { Routes, Route,Link } from 'react-router-dom'

import { AppStateProvider, useAppStateContext } from './util/CommonState'
import { isLogin, getUser } from './util/LoginUser'

import Logo from './img/logo.png'

import TopPage from './pages/TopPage'
import UserPage from './pages/UserPage'
import TenantPage from './pages/TenantPage'
import AdminPage from './pages/AdminPage'
import LoginPage from './pages/LoginPage'

import SideMenu from './component/SideMenu'
import UserInfo from './component/UserInfo'
import SysAdminPage from './pages/SysAdmin'
import UserSettingPage from './pages/UserSettingPage'


export default function App() {

  const theme = createTheme(
    {
      palette: {
        primary: {
          main: '#1e5181',
        },
        secondary: {
          main: '#7ba7c1',
        },
        background: {
          default: '#f5f5f5',
        },
        action: {
          active: '#2b2d42',
        },
        text: {
          primary: '#1c242f',
        },
      },
    },
  )

  const [menuOpen, setMenuOpen] = useState(false)
  const [mainPosition, setMainPosition] = useState(0)
  const [loginStatus, changeLoginStatus] = useState(isLogin())

  const [snackBar,setSnackBar] = useState(false);

  const renderFlgRef = useRef(false)

  useEffect(()=>{

    // if(renderFlgRef.current) {
    //   if(!loginStatus){
    //     console.log("Error による再ログイン")
    //     setSnackBar(true);
    //   }
    // }else{
    //   renderFlgRef.current = true;
    // }

  },[loginStatus])

  const open = () => {
    setMenuOpen(true)
    setMainPosition(25)
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {loginStatus ?
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Box sx={{ flexGrow: 0 }}>
                <AppBar position='static' color='action' sx={{ ml: mainPosition }}>
                  <Toolbar>
                    <IconButton size='large' onClick={() => {
                      open()
                    }}>
                      <MenuIcon />
                    </IconButton>
                    <Box sx={{ ml: 1, mt: 2 }}>
                      <Link to={'/'}>
                        <img src={Logo} width='75%' height='75%' />
                      </Link>
                    </Box>
                    <Typography variant='h6' sx={{ ml: 2, flexGrow: 1 }}>
                      テナント管理
                    </Typography>

                    <UserInfo logout={changeLoginStatus} />

                  </Toolbar>
                </AppBar>

              </Box>
            </Grid>

            <Grid item xs={12} md={1}>
              <SideMenu open={menuOpen} controlfunc={setMenuOpen} setMainPosition={setMainPosition} />
            </Grid>
            <Grid item xs={12} md={11}>
              <AppStateProvider>
                <Routes>
                  <Route path='/' element={<TopPage  login={changeLoginStatus}  />} />
                  <Route path='/tenant'element={<TenantPage login={changeLoginStatus}  />} />
                  <Route path='/adminuser' element={<AdminPage login={changeLoginStatus}  />} />
                  <Route path='/user' element={<UserPage  login={changeLoginStatus} />} />
                  <Route path='/sysadmin' element={<SysAdminPage  login={changeLoginStatus} />} />
                  <Route path='/setting' element={<UserSettingPage  login={changeLoginStatus} />} />
                </Routes>
              </AppStateProvider>
            </Grid>
          </Grid>
        </>
        : (<>
            <LoginPage login={changeLoginStatus} />
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackBar}
            onClose={()=>{setSnackBar(false)}}
            message={"セッションタイムアウトあるいはエラーが起こったため再ログインをお願いします"}
            key='errorLogin'
          />
          </>)
      }
    </ThemeProvider>
  )
}
